/* =========================
   ÆGLØSNINGSBEREGNER
   Finder og binder kun hvis .gt-ovu-box findes
========================= */
(function () {
  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('da-DK', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  function calculate(box) {
    var startInput = box.querySelector('.gt-ovu-start');
    var lengthInput = box.querySelector('.gt-ovu-len');
    var output = box.querySelector('.gt-ovu-out');

    if (!startInput || !lengthInput || !output) return;

    var startDate = startInput.value;
    var cycleLength = parseInt(lengthInput.value, 10);

    output.style.display = 'block';

    if (!startDate || isNaN(cycleLength) || cycleLength < 21 || cycleLength > 40) {
      output.innerHTML =
        '<p>Udfyld venligst begge felter med gyldige værdier (21–40 dage).</p>';
      return;
    }

    var firstDay = new Date(startDate + 'T00:00:00');
    if (isNaN(firstDay.getTime())) {
      output.innerHTML =
        '<p>Datoen kunne ikke læses. Prøv at vælge den igen.</p>';
      return;
    }

    // Ægløsning ca. 14 dage før næste menstruation
    var ovulationDate = addDays(firstDay, cycleLength - 14);

    // Fertile dage: ca. 5 dage før ægløsning + ægløsningsdagen
    var fertileFrom = addDays(ovulationDate, -5);

    output.innerHTML =
      '<p>Estimeret ægløsning: <strong>' + formatDate(ovulationDate) + '</strong></p>' +
      '<p>Fertile dage (ca.): <strong>' +
      formatDate(fertileFrom) + ' – ' + formatDate(ovulationDate) +
      '</strong></p>';
  }

  function bindCalculators() {
    var boxes = document.querySelectorAll('.gt-ovu-box');
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      var button = box.querySelector('.gt-ovu-btn');
      if (!button) return;

      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';

      button.addEventListener('click', function () {
        calculate(box);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCalculators);
  } else {
    bindCalculators();
  }

  document.addEventListener('shopify:section:load', bindCalculators);
})();

/* =========================
   HCG FORDOBLINGSTID BEREGNER
   Binder kun hvis #hcg-calc findes
   Læser kun felter inde i boksen (ingen konflikter)
========================= */
(function () {
  function bindHcg() {
    var box = document.getElementById('hcg-calc');
    if (!box) return;

    var btn = box.querySelector('#hcgCalcBtn');
    var out = box.querySelector('#hcg-result');
    if (!btn || !out) return;

    if (btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    function fmtNumber(x) {
      return (Math.round(x * 10) / 10).toString().replace('.', ',');
    }

    btn.addEventListener('click', function () {
      var hcg1 = parseFloat((box.querySelector('#hcg1') || {}).value);
      var hcg2 = parseFloat((box.querySelector('#hcg2') || {}).value);
      var hours = parseFloat((box.querySelector('#timeDifference') || {}).value);

      if (!isFinite(hcg1) || !isFinite(hcg2) || !isFinite(hours) || hcg1 <= 0 || hcg2 <= 0 || hours <= 0) {
        out.innerHTML = '<p>Udfyld venligst alle felter med tal større end 0.</p>';
        return;
      }

      var ratio = hcg2 / hcg1;

      if (ratio === 1) {
        out.innerHTML = '<p>HCG er uændret. Fordoblingstid kan ikke beregnes (uendelig).</p>';
        return;
      }

      // t_d = t * ln(2) / ln(hcg2/hcg1)
      var doublingHours = hours * Math.log(2) / Math.log(ratio);

      if (!isFinite(doublingHours)) {
        out.innerHTML = '<p>Kunne ikke beregne fordoblingstiden med de indtastede værdier.</p>';
        return;
      }

      var direction = (ratio > 1) ? 'stiger' : 'falder';

      // Hvis ratio < 1 bliver ln(ratio) negativ => doublingHours bliver negativ.
      // Vi viser derfor "halveringstid" i stedet i det tilfælde.
      if (doublingHours < 0) {
        var halvingHours = Math.abs(doublingHours);
        var halvingDays = halvingHours / 24;

        out.innerHTML =
          '<div style="border:1px solid #eee;background:#f9f9f9;padding:15px;border-radius:8px;">' +
            '<p>Din hCG ' + direction + ' i perioden.</p>' +
            '<p>Estimeret halveringstid: <strong>' + fmtNumber(halvingHours) + ' timer</strong> (ca. ' + fmtNumber(halvingDays) + ' dage)</p>' +
          '</div>';
        return;
      }

      var doublingDays = doublingHours / 24;

      out.innerHTML =
        '<div style="border:1px solid #eee;background:#f9f9f9;padding:15px;border-radius:8px;">' +
          '<p>Din hCG ' + direction + ' i perioden.</p>' +
          '<p>Estimeret fordoblingstid: <strong>' + fmtNumber(doublingHours) + ' timer</strong> (ca. ' + fmtNumber(doublingDays) + ' dage)</p>' +
        '</div>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHcg);
  } else {
    bindHcg();
  }

  document.addEventListener('shopify:section:load', bindHcg);
})();
/* =========================
   FERTILITET & ALDER BEREGNER
   Binder kun hvis .gt-age-box findes
========================= */
(function () {
  function bindAgeCalc() {
    var boxes = document.querySelectorAll('.gt-age-box');
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      var input = box.querySelector('.gt-age-input');
      var btn = box.querySelector('.gt-age-btn');
      var out = box.querySelector('.gt-age-out');
      if (!input || !btn || !out) return;

      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      function chanceText(age) {
        if (age <= 24) return 'ca. 30% chance pr. cyklus';
        if (age <= 29) return 'ca. 25% chance pr. cyklus';
        if (age <= 34) return 'ca. 20% chance pr. cyklus';
        if (age <= 37) return 'ca. 15% chance pr. cyklus';
        if (age <= 40) return 'ca. 10% chance pr. cyklus';
        if (age <= 43) return 'ca. 5% chance pr. cyklus';
        return 'under 2% chance pr. cyklus';
      }

      btn.addEventListener('click', function () {
        var age = parseInt(input.value, 10);
        out.style.display = 'block';

        if (!isFinite(age) || age < 18 || age > 50) {
          out.innerHTML = '<p>Indtast venligst en gyldig alder mellem 18 og 50.</p>';
          return;
        }

        out.innerHTML =
          '<p>Din estimerede fertilitetschance er <strong>' + chanceText(age) + '</strong>.</p>' +
          '<p style="margin-top:8px;font-size:14px;opacity:0.8;">Bemærk: Dette er en generel vurdering og siger ikke noget om din personlige fertilitet.</p>';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAgeCalc);
  } else {
    bindAgeCalc();
  }

  // Nogle temaer loader artikelindhold “sent”, så vi binder også igen
  window.addEventListener('load', bindAgeCalc);
  document.addEventListener('shopify:section:load', bindAgeCalc);
  setTimeout(bindAgeCalc, 500);
  setTimeout(bindAgeCalc, 1500);
})();
/* =========================
   TIDLIG GRAVIDITETSTEST-BEREGNER (8 DPO)
   Binder kun hvis .gt-earlytest-box findes
   Kan beregne ud fra seneste ægløsning ELLER seneste menstruation + cykluslængde
========================= */
(function () {
  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('da-DK', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  function parseDate(val) {
    if (!val) return null;
    var d = new Date(val + 'T00:00:00');
    return isNaN(d.getTime()) ? null : d;
  }

  function getMode(box, groupName) {
    var checked = box.querySelector('input[name="' + groupName + '"]:checked');
    return checked ? checked.value : 'ovu';
  }

  function toggleMode(box, groupName) {
    var mode = getMode(box, groupName);

    var ovuWrap = box.querySelector('.gt-earlytest-ovu-wrap');
    var lmpWrap = box.querySelector('.gt-earlytest-lmp-wrap');

    if (ovuWrap) ovuWrap.style.display = (mode === 'ovu') ? 'block' : 'none';
    if (lmpWrap) lmpWrap.style.display = (mode === 'lmp') ? 'block' : 'none';
  }

  function calculate(box, groupName) {
    var out = box.querySelector('.gt-earlytest-out');
    if (!out) return;

    out.style.display = 'block';

    var mode = getMode(box, groupName);

    var ovuInput = box.querySelector('.gt-earlytest-ovu-date');
    var lmpInput = box.querySelector('.gt-earlytest-lmp-date');
    var lenInput = box.querySelector('.gt-earlytest-len');

    var ovulationDate = null;
    var expectedPeriod = null;

    if (mode === 'ovu') {
      ovulationDate = parseDate(ovuInput ? ovuInput.value : '');
      if (!ovulationDate) {
        out.innerHTML = '<p>Vælg venligst dato for din seneste ægløsning.</p>';
        return;
      }

      // Typisk “forventet menstruation” ≈ 14 dage efter ægløsning
      expectedPeriod = addDays(ovulationDate, 14);
    } else {
      var lmpDate = parseDate(lmpInput ? lmpInput.value : '');
      var cycleLength = parseInt(lenInput ? lenInput.value : '', 10);

      if (!lmpDate || !isFinite(cycleLength) || cycleLength < 21 || cycleLength > 40) {
        out.innerHTML = '<p>Udfyld venligst dato for seneste menstruation og en cykluslængde på 21–40 dage.</p>';
        return;
      }

      expectedPeriod = addDays(lmpDate, cycleLength);

      // Ægløsning estimeret ca. 14 dage før næste menstruation
      ovulationDate = addDays(lmpDate, cycleLength - 14);
    }

    // Tidlig test-logik (8 DPO som “tidligst”)
    var earliestTest = addDays(ovulationDate, 8);   // 8 DPO
    var betterTest = addDays(ovulationDate, 10);    // 10 DPO (ofte bedre end 8)
    var mostReliable = expectedPeriod;              // mest sikkert omkring forventet mens

    out.innerHTML =
      '<div style="border:1px solid #eee;background:#f9f9f9;padding:15px;border-radius:8px;">' +
        '<p><strong>Estimeret ægløsning:</strong> ' + formatDate(ovulationDate) + '</p>' +
        '<p><strong>Tidligst (8 dage efter ægløsning):</strong> ' + formatDate(earliestTest) + '</p>' +
        '<p><strong>Bedre chance for positiv:</strong> ' + formatDate(betterTest) + '</p>' +
        '<p><strong>Mest sikkert resultat:</strong> omkring ' + formatDate(mostReliable) + '</p>' +
        '<p style="margin-top:10px;font-size:14px;opacity:0.85;">Bemærk: Det er normalt at teste negativt tidligt, selvom du er gravid. hCG stiger forskelligt fra person til person, og implantation kan ske senere. Test gerne igen efter 1–2 dage eller på dagen for forventet menstruation.</p>' +
      '</div>';
  }

  function bindEarlyTest() {
    var boxes = document.querySelectorAll('.gt-earlytest-box');
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      var btn = box.querySelector('.gt-earlytest-btn');
      if (!btn) return;

      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      // Gør radio-gruppen unik pr. beregner (så flere beregnere ikke konflikter)
      var radios = box.querySelectorAll('.gt-earlytest-mode');
      var groupName = 'gtEarlyMode_' + Math.random().toString(36).slice(2, 9);
      radios.forEach(function (r) { r.setAttribute('name', groupName); });

      // Init visning
      toggleMode(box, groupName);

      // Toggle ved skift
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          toggleMode(box, groupName);
        });
      });

      // Beregn
      btn.addEventListener('click', function () {
        calculate(box, groupName);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEarlyTest);
  } else {
    bindEarlyTest();
  }

  document.addEventListener('shopify:section:load', bindEarlyTest);
  window.addEventListener('load', bindEarlyTest);
})();
/* =========================
   ÆGLØSNINGSTEST-BEREGNER (artikel-specifik)
   Binder kun hvis felterne findes
========================= */
(function () {
  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('da-DK', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  function bindOvulationTestCalculator() {
    var startInput = document.getElementById('menstruationStart');
    var cycleInput = document.getElementById('cyklusLaengde');
    var output = document.getElementById('resultat');

    if (!startInput || !cycleInput || !output) return;

    var box = output.closest('div');
    if (!box) return;

    var button = box.querySelector('button');
    if (!button) return;

    if (button.dataset.boundOvulationTest === '1') return;
    button.dataset.boundOvulationTest = '1';

    button.addEventListener('click', function () {
      var startDate = startInput.value;
      var cycleLength = parseInt(cycleInput.value, 10);

      output.style.display = 'block';

      if (!startDate || isNaN(cycleLength) || cycleLength < 21 || cycleLength > 40) {
        output.innerHTML = '<p>Udfyld venligst begge felter med gyldige værdier (21–40 dage).</p>';
        return;
      }

      var firstDay = new Date(startDate + 'T00:00:00');
      if (isNaN(firstDay.getTime())) {
        output.innerHTML = '<p>Datoen kunne ikke læses. Prøv at vælge den igen.</p>';
        return;
      }

      // Forventet ægløsning ca. 14 dage før næste menstruation
      var ovulationDate = addDays(firstDay, cycleLength - 14);

      // Start med ægløsningstest ca. 17 dage før næste menstruation
      var testStartDate = addDays(firstDay, cycleLength - 17);

      output.innerHTML =
        '<div style="border:1px solid #eee;background:#f9f9f9;padding:15px;border-radius:8px;">' +
          '<p>Du kan begynde at teste med ægløsningstest omkring: <strong>' + formatDate(testStartDate) + '</strong></p>' +
          '<p>Estimeret ægløsning: <strong>' + formatDate(ovulationDate) + '</strong></p>' +
        '</div>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOvulationTestCalculator);
  } else {
    bindOvulationTestCalculator();
  }

  window.addEventListener('load', bindOvulationTestCalculator);
  document.addEventListener('shopify:section:load', bindOvulationTestCalculator);
  setTimeout(bindOvulationTestCalculator, 500);
  setTimeout(bindOvulationTestCalculator, 1500);
})();

/* =========================
   ÆGLØSNINGSTEST-BEREGNER (artikel-specifik)
   Binder kun hvis felterne findes
========================= */
(function () {
  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('da-DK', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  function bindOvuTestCalc() {
    var startInput = document.getElementById('menstruationStart');
    var cycleInput = document.getElementById('cyklusLaengde');
    var button = document.getElementById('beregnOvuTestBtn');
    var output = document.getElementById('resultat');

    if (!startInput || !cycleInput || !button || !output) return;

    if (button.dataset.bound === '1') return;
    button.dataset.bound = '1';

    button.addEventListener('click', function () {
      var startDate = startInput.value;
      var cycleLength = parseInt(cycleInput.value, 10);

      output.style.display = 'block';

      if (!startDate || isNaN(cycleLength) || cycleLength < 21 || cycleLength > 40) {
        output.innerHTML = '<p>Udfyld venligst begge felter med gyldige værdier (21–40 dage).</p>';
        return;
      }

      var firstDay = new Date(startDate + 'T00:00:00');
      if (isNaN(firstDay.getTime())) {
        output.innerHTML = '<p>Datoen kunne ikke læses. Prøv at vælge den igen.</p>';
        return;
      }

      var ovulationDate = addDays(firstDay, cycleLength - 14);
      var testStartDate = addDays(firstDay, cycleLength - 17);

      output.innerHTML =
        '<div style="border:1px solid #eee;background:#f9f9f9;padding:15px;border-radius:8px;">' +
          '<p>Du kan begynde at teste med ægløsningstest omkring: <strong>' + formatDate(testStartDate) + '</strong></p>' +
          '<p>Estimeret ægløsning: <strong>' + formatDate(ovulationDate) + '</strong></p>' +
        '</div>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOvuTestCalc);
  } else {
    bindOvuTestCalc();
  }

  window.addEventListener('load', bindOvuTestCalc);
  document.addEventListener('shopify:section:load', bindOvuTestCalc);
  setTimeout(bindOvuTestCalc, 500);
  setTimeout(bindOvuTestCalc, 1500);
})();
